import axios from 'axios'
import {handleError} from '../handleError'
import {LError} from '../../object'
const state = {
  moduleList: []
}
const mutations = {
  setModuleList (state, items) {
    state.moduleList = items
  }
}
const getters = {}
const actions = {
  /*async getMessageLog ({dispatch}, {pagination, searchParam}) {
    let url = '/messageApi/IMService/logs?page=' + (pagination.page - 1) + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = await axios.post(url, searchParam)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },*/
  async getMessageLog ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/messageApi/IMService/loglist',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  async getModuleList ({dispatch, commit}) {
    let url = '/messageApi/module/list'
    try {
      let res = null
      res = await axios.get(url)
      // commit('setModuleList',res)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getModuleLabel ({dispatch}, key) {
    let url = '/messageApi/module/' + key + '/label'
    try {
      let res = null
      res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getTemplateList ({dispatch}, {searchParam, pagination}) {
    let url = '/messageApi/IMService/templates/?page=' + (pagination.page - 1) + '&size=' + pagination.rowsPerPage
    try {
      let res = null
      res = await axios.post(url, searchParam)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async deleteTemplate ({dispatch}, ids) {
    let url = '/messageApi/IMService/template'
    try {
      let res = null
      res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async addTemplate ({dispatch}, templateInfo) {
    let url = '/messageApi/IMService/template'
    try {
      let res = null
      res = await axios.put(url, templateInfo)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async sendSmsMessage ({dispatch}, item) {
    let url = '/messageApi/IMService/sendByModule'
    try {
      let res = null
      res = await axios.post(url, item)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  }
}
export default{
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
